export default __webpack_public_path__ + "static/media/3k.38ee6e3b.gif";